import { Box, Typography } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

import "./style.scss"

interface SourcePanelHeadingProps {
  inputHeading: string
  tooltipBase: string
  sourceInputSummary: string
  interactionDisabled?: boolean
}

export function SourcePanelHeading({
  inputHeading,
  tooltipBase,
  sourceInputSummary,
  interactionDisabled = false,
}: SourcePanelHeadingProps) {
  return (
    <Box className="components_optimization-source-heading">
      <Typography component="span" className="optimization-source-heading-label">
        {`${inputHeading}:`}
      </Typography>
      <Typography component="span" className="optimization-source-heading-summary">
        {sourceInputSummary}
      </Typography>
      <Tooltip
        title={interactionDisabled ? "" : tooltipBase}
        disableHoverListener={interactionDisabled}
        disableFocusListener={interactionDisabled}
        disableTouchListener={interactionDisabled}
      >
        <span className={interactionDisabled ? "optimization-source-heading-info-icon-wrap" : undefined}>
          <InfoOutlined
            className="optimization-source-heading-info-icon"
            aria-label="About optimization input"
            aria-hidden={interactionDisabled}
            tabIndex={interactionDisabled ? -1 : 0}
          />
        </span>
      </Tooltip>
    </Box>
  )
}
